import * as Y from 'yjs';
import { yMeta, yElements, yLines } from './schema';
import { ORIGIN_LOCAL } from './transact';
import { _setUndoManager } from './doc';

const CAPTURE_TIMEOUT_MS = 500;

export function createUndoManager(doc) {
    const undo = new Y.UndoManager(
        [yElements(doc), yLines(doc), yMeta(doc)],
        {
            trackedOrigins: new Set([ORIGIN_LOCAL]),
            captureTimeout: CAPTURE_TIMEOUT_MS,
        },
    );
    _setUndoManager(undo);
    return undo;
}

export function bridgeUndoStateToRedux(undo, store, setUndoState) {
    const sync = () => {
        store.dispatch(setUndoState({
            canUndo: undo.undoStack.length > 0,
            canRedo: undo.redoStack.length > 0,
        }));
    };
    undo.on('stack-item-added',  sync);
    undo.on('stack-item-popped', sync);
    sync();
    return () => {
        undo.off('stack-item-added',  sync);
        undo.off('stack-item-popped', sync);
    };
}
